import { Route } from "@dashboard/components/Router";
import { sectionNames } from "@dashboard/intl";
import { asSortParams } from "@dashboard/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { RouteComponentProps, Switch } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  sampleRequestListPath,
  SampleRequestListUrlQueryParams,
  SampleRequestListUrlSortField,
} from "./urls";
import SampleRequestListComponent from "./views/SampleRequestList/SampleRequestList";

const SampleRequestList = ({ location }: RouteComponentProps<any>) => {
  const qs = parseQs(location.search.substr(1)) as any;
  const params: SampleRequestListUrlQueryParams = asSortParams(
    qs,
    SampleRequestListUrlSortField,
    SampleRequestListUrlSortField.date,
    false,
  );

  return <SampleRequestListComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.sampleRequests)} />
      <Switch>
        <Route exact path={sampleRequestListPath} component={SampleRequestList} />
      </Switch>
    </>
  );
};

export default Component;